<section [id]="pageData.scrollId" class="bloque-de-bienvenida-section">
    <img class="bloque-de-bienvenida-img" [src]="rutaImagen" alt="">
    <br>
    <div class="cursor-default">
      <!-- #titleElement LE PERTENECE A LA BIBLIOTEGA gsap -->
      <p class="subtitle my-5" #titleElement>
          Proveemos de cannabis a socios inscriptos en Reprocann.
      </p>
    </div>
    <button class="bloque-de-bienvenida-btn-asociarme" (click)="irAInscribirse()">Hacete socio</button>
</section>